import { List } from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";

import { GROUPS, TOTAL_GROUP } from "./constants";
import { StatisticsDatagrid } from "./StatisticsDatagrid";

interface StatisticsListByZoneIdProps {
  zoneId?: string;
  filters?: Record<string, unknown>;
}
export const StatisticsListByZoneId = ({
  zoneId,
  filters,
}: StatisticsListByZoneIdProps) => (
  <List
    resource={MODULE_NAMES.STATISTICS}
    filter={{
      ...(zoneId && zoneId !== TOTAL_GROUP ? { tracker_zone_id: zoneId } : {}),
      ...filters,
      group: GROUPS.COUNTRY,
    }}
    pagination={false}
    actions={false}
    storeKey={false}
  >
    <StatisticsDatagrid sx={{ overflowX: "auto" }} />
  </List>
);
